import { AlpineComponent } from 'alpinejs';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const Gallery = (): AlpineComponent => ({
  activeIndex: 0,
  images: null,
  lightbox: null,

  init() {
    this.images = this.$root.querySelectorAll('.gallery__image > a');
    this.lightbox = new PhotoSwipeLightbox({
      gallery: this.$root,
      children: this.images,
      showHideAnimationType: 'fade',
      pswpModule: () => import('photoswipe')
    });

    this.lightbox.init();

    const slider = this.$root.querySelector('.swiper');
    const swiper = new Swiper(slider, {
      modules: [Navigation, Pagination],
      loop: true,
      speed: 450,
      pagination: {
        type: 'fraction',
        el: '.swiper-pagination',
        renderFraction: (curr, total) =>
          `<span class="${curr}"></span> | <span class="${total}"></span>`
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });

    swiper.on('slideChange', () => {
      this.activeIndex = swiper.realIndex;
    });
  },
  openLightbox() {
    this.lightbox.loadAndOpen(this.activeIndex);
  }
});

export default Gallery;
